<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">邮件</a></li>
                <li><a href="#">邮件详情</a></li>
            </ul>
        </div>
    
        <div class="formbody">
            <div id="usual1" class="usual">
                <div id="tab1" class="tabson">        
                    <div class="formtext">传真及会议、邮件资费调整通知<a href="#">邮件指南</a>能！</div>    
                    <ul class="forminfo">
                        <li v-show="false" ><input v-model="format" /></li>
                        <li v-show="false" ><input v-model="num" /></li>
                        <li><label>发送邮箱</label><textarea name="" v-model="email" cols="" rows="" class="textinput left"></textarea><div class="buttonupload  click left" style="margin-left:20px;">文件导入txt</div></li>
                        
                        <li><label> &nbsp; </label><div class="toolbars lh33">邮箱间需以空格 或分号；或逗号，相隔；或一行一个邮箱；</div></li>
                        
                        <li><label>标题</label><input name="" v-model="title" type="text" class="dfinput" /><i></i></li>
                        
                        <li><label>通道</label>
                            <div class="cityleft">
                                <el-select v-model="channel" style="width:500px;">
                                    <el-option label="通道1，2分/封，发送速度慢，可追踪大部分邮件打开的状态"  value="1"></el-option>
                                </el-select>
                            </div> 
                        </li>
    
                        <li style="height:300px;"><label>内容</label>
                        <!-- <div class="qecontent"> -->                            
                            <editor-bar :value="editor.info" style="width:700px;height:300px;margin:0px 5px 15px 85px;" v-model="editor.info" :isClear="isClear" @change="change"></editor-bar>
                        <!-- </div> -->
                        </li>
    
                        <li><label>&nbsp;</label><input name="" type="button" @click="sendemail()" class="btn" value="提交"/></li>
    
                    </ul>
    
                    <div class="jian">&nbsp;</div>
                    <div class="welinfo">
                        <span><img src="../../assets/images/dp.png" alt="提醒" /></span>
                        <b>二办邮件使用说明</b>
                    </div>
    
                    <ul class="infolist">
                        <li><span>试用期间充值划账满百优惠</span></li> 
                        <li><span>1、使用本站邮件群发或单发均需付费，标准资费2分/封，量大优惠，详见资费表及划账优惠</span></li> 
                        <li><span>2、使用者需通过手机及邮件验证，承诺不使用本站邮件系统发送违法内容及侮辱性、欺诈性邮件，否则冻结账户并举报至公安</span></li>
                        <li><span>3、邮件内容请限制在20－50K内，群发前请自行测试，敏感关键字或被屏蔽；一次群发20人以上的邮件需经客服审核；提交前请保持余额充足</span></li>
                        <li><span>4、图片及链接发送  请把图片先上传到网络空间后，填写相应URL到内容中 ，直接粘贴的图片可能不会被对方邮件系统显示（见附）；不可发送附件</span></li>
                        <li><span>5、邮件可显示您指定的邮箱或昵称，但对方不可直接回复;指定邮箱需经验证审核，防止误用他人邮箱；</span></li>
                        <li><span>（可用该邮箱向kefu@2office.cn 发送一封验证邮件以加快验证）</span></li>
                        <li><span>6、邮件内容中请提醒对方：</span></li>
                        <li><span>（1）不可直接回复</span></li>
                        <li><span>（2）对方如不愿接收，退订如何联络</span></li>
                        <li><span>7、对方有无打开邮件可通过已发邮件中查看（部分通道不支持）</span></li>
                        <li><span>8、后期 将推出内容代编辑、代检测、保存草稿及个性邮件（即批量发送不同内容的邮件，如加上用户姓名的邮件），帮助提高邮件效果。</span></li>
                        <li><span>其他使用建议请留言或联络客服，谢谢！</span></li>
                    </ul>    
                </div> 
            </div>       
	    </div> 
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
import EditorBar from '@/components/EditorBar'
var eb = EditorBar;
export default {
    data(){
        return{
            editorOption:{},
            editor: {
                info: ''
            },
            isClear: false,
            channel:'1',
            email:'',
            title:'',
            format:'',
            num:0,
        }
    },
    mounted(){
        this.getDate();
    },
    methods:{
        onEditorBlur(){//失去焦点事件
        },
        onEditorFocus(){//获得焦点事件
        },
        onEditorChange(){//内容改变事件
        },
        change (val) {
            this.editor.info = val
        },
        sendemail(){
           if(this.email.trim() == '')
            {
                alert("邮箱地址不能为空！");
                return;
            }
            if(this.editor.info.trim() == '')
            {
                alert("邮箱内容不能为空！");
                return;
            }
            var that = this;
            let data = {'title':this.title,'content':this.editor.info,'email':this.email,'format':this.format,'channl':this.channel,'num':this.num}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/email/sendemail.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    alert("邮件提交成功！");
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        getDate(){
            var that = this
            let data = {'id':this.$route.query.id}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/email/getemaillogdetail.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.email = res.data.emaillog.email;
                    that.title = res.data.emaillog.title;
                    that.editor.info = res.data.emaillog.content;
                    eb.methods.setContent(res.data.emaillog.content)
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
    },
    components: {
        'v-cookie' : cookie,
        EditorBar
    },
}
</script>
<style>
.qe{width:600px; height:400px;}
</style>



// WEBPACK FOOTER //
// src/components/email/emaillogdetail.vue